<template>
  <div class="cms-category-form">
    <drawer-dialog-controls
      :is-loading="isLoading"
      :is-pristine="isPristine"
      :is-disabled="!isFormValid"
      @close="$emit('close')"
      @save="$emit('save', localItem)"
    >
      {{ isNew ? 'New Category' : `Edit Category #${item.category_id}` }}
    </drawer-dialog-controls>

    <div class="form-content">
      <v-form v-model="isFormValid">
        <v-card>
          <v-card-title>Category Settings</v-card-title>
          <v-divider />
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-select
                  v-model="localItem.type_id"
                  :items="types"
                  item-text="name"
                  item-value="type_id"
                  label="Type"
                  :rules="[v => !!v || 'Type is required']"
                  :disabled="!isNew"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="localItem.slug"
                  label="Slug"
                  :rules="[v => !!v || 'Slug is required']"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="localItem.name"
                  label="Name"
                  :rules="[v => !!v || 'Name is required']"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model.number="localItem.sort_order"
                  label="Sort Order"
                  type="number"
                />
              </v-col>
              <v-col cols="6">
                <v-switch
                  v-model="localItem.is_active"
                  label="Active"
                  color="primary"
                />
              </v-col>
            </v-row>
            <v-row v-if="!hasBase">
              <v-col cols="12">
                <v-switch
                  v-model="isGlobal"
                  label="Global (default) — visible in all projects"
                  color="primary"
                  hide-details
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { DrawerDialogControls } from '@/components/core/DrawerDialog'

export default {
  components: {
    DrawerDialogControls,
  },
  props: {
    item: Object,
    types: Array,
    isLoading: Boolean,
    entityId: { type: [Number, String], default: null },
    hasBase: { type: Boolean, default: false },
  },
  data() {
    return {
      localItem: {},
      isPristine: true,
      isFormValid: false,
    }
  },
  computed: {
    isNew() {
      return !this.item.category_id
    },
    isGlobal: {
      get() {
        return !this.localItem.entity_id
      },
      set(v) {
        this.$set(this.localItem, 'entity_id', v ? null : this.entityId)
      },
    },
  },
  created() {
    this.localItem = cloneDeep(this.item || {})
    const unwatch = this.$watch('localItem', () => {
      this.isPristine = false
      unwatch()
    }, { deep: true })
  },
}
</script>

<style scoped>
.form-content {
  background-color: #F2F2F2;
  padding: 1rem;
}
</style>